export const GET_USER_DETAIL_REQUEST = "supporter/GET_USER_DETAIL_REQUEST";
export const GET_USER_DETAIL_SUCCESS = "supporter/GET_USER_DETAIL_SUCCESS";
export const GET_USER_DETAIL_FAILURE = "supporter/GET_USER_DETAIL_FAILURE";

export const GET_PATIENT_REQUEST = "supporter/GET_PATIENT_REQUEST";
export const GET_PATIENT_SUCCESS = "supporter/GET_PATIENT_SUCCESS";
export const GET_PATIENT_FAILURE = "supporter/GET_PATIENT_FAILURE";

export const GET_SUPPORTER_REQUEST = "supporter/GET_SUPPORTER_REQUEST";
export const GET_SUPPORTER_SUCCESS = "supporter/GET_SUPPORTER_SUCCESS";
export const GET_SUPPORTER_FAILURE = "supporter/GET_SUPPORTER_FAILURE";

export const FOLLOW_SUPPORTER_REQUEST = "supporter/FOLLOW_SUPPORTER_REQUEST";
export const FOLLOW_SUPPORTER_SUCCESS = "supporter/FOLLOW_SUPPORTER_SUCCESS";
export const FOLLOW_SUPPORTER_FAILURE = "supporter/FOLLOW_SUPPORTER_FAILURE";

export const GET_FOLLOW_SUPPORTER_REQUEST =
  "supporter/GET_FOLLOW_SUPPORTER_REQUEST";
export const GET_FOLLOW_SUPPORTER_SUCCESS =
  "supporter/GET_FOLLOW_SUPPORTER_SUCCESS";
export const GET_FOLLOW_SUPPORTER_FAILURE =
  "supporter/GET_FOLLOW_SUPPORTER_FAILURE";

export const GET_HISTORY_CHAT_REQUEST = "supporter/GET_HISTORY_CHAT_REQUEST";
export const GET_HISTORY_CHAT_SUCCESS = "supporter/GET_HISTORY_CHAT_SUCCESS";
export const GET_HISTORY_CHAT_FAILURE = "supporter/GET_HISTORY_CHAT_FAILURE";

export const GET_PATIENT_CHATED_REQUEST =
  "supporter/GET_PATIENT_CHATED_REQUEST";
export const GET_PATIENT_CHATED_SUCCESS =
  "supporter/GET_PATIENT_CHATED_SUCCESS";
export const GET_PATIENT_CHATED_FAILURE =
  "supporter/GET_PATIENT_CHATED_FAILURE";

export const SET_DATA_SUPPORTER = "supporter/SET_DATA_SUPPORTER";
export const SET_DATA_CHAT = "supporter/SET_DATA_CHAT";
export const SET_PATIENT_CHATED_LIST = "supporter/SET_PATIENT_CHATED_LIST";
export const SET_FILTER = "supporter/SET_FILTER";
export const SET_TYPING = "supporter/SET_TYPING";

export const SHOW_LOADING = "supporter/SHOW_LOADING";
export const HIDE_LOADING = "supporter/HIDE_LOADING";

export const SHOW_LOADING_HISTORY = "supporter/SHOW_LOADING_HISTORY";
export const HIDE_LOADING_HISTORY = "supporter/HIDE_LOADING_HISTORY";
